import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export default function Markdown({ content, children, testId }) {
  const text = content || children || "";
  return (
    <div data-testid={testId} className="prose prose-slate max-w-none prose-p:leading-7 prose-li:leading-7">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
    </div>
  );
}
